import { apiService } from './index';

// Inport types
import { ISelect, ParamEnum } from '../shared/types/shared';
import {
    RedirectParams,
    RedirectParamsHistorical,
} from '../shared/types/redirectParams';
import {
    Motive,
    MotiveHistorical,
} from '../shared/types/systemConfiguration/motives';

export const asyncGetParams = async (
    classParam?: ParamEnum,
    parentCode?: string,
    parentId?: any,
    name?: string,
    extra?: string,
    active?: boolean,
    page?: number,
    pageSize?: number
): Promise<ISelect[]> => {
    try {
        const { items }: any = await apiService.get(`/api/param`, {
            class: classParam || '',
            parentCode: parentCode || '',
            parentId: parentId || '',
            name: name || '',
            extra: extra || '',
            active: active,
            limit: pageSize || 0,
            page: page || 0,
        });

        return items || [];
    } catch (error) {
        return [];
    }
};

export const asyncGetParamsWithGroupParent = async (
    classParam?: ParamEnum,
    parent?: string[],
    name?: string,
    extra?: string,
    active?: boolean,
    page?: number,
    pageSize?: number
): Promise<ISelect[]> => {
    try {
        const { items }: any = await apiService.get(
            `/api/param/group-by-parent`,
            {
                class: classParam || '',
                parent: parent || [],
                name: name || '',
                extra: extra || '',
                active: active,
                limit: pageSize || 0,
                page: page || 0,
            }
        );

        return items || [];
    } catch (error) {
        return [];
    }
};

export const asyncGetLabelParams = async (
    classParam?: ParamEnum
): Promise<ISelect[]> => {
    try {
        if (!Boolean(classParam?.trim())) return [];

        const { items }: any = await apiService.get(
            `/api/param/labels/${classParam}`
        );

        return items || [];
    } catch (error) {
        return [];
    }
};

export const asyncGetParamByCode = async (
    code: string
): Promise<ISelect | undefined> => {
    try {
        const { items }: any = await apiService.get(
            `/api/param/by-code/${code}`
        );
        return items;
    } catch (error) {}
};

export const asyncGetParamById = async (
    id: string
): Promise<ISelect | undefined> => {
    try {
        const { items }: any = await apiService.get(`/api/param/${id}`);
        return items || [];
    } catch (error) {}
};

export const asyncDeleteParam = async (id: string | number) => {
    return await apiService.delete(`/api/param/${id}`);
};

export const asyncReactivateParam = async (id: string | number) => {
    return await apiService.patch(`/api/param/reactivate/${id}`);
};

export const asyncPostParam = async (
    formParam: RedirectParams
): Promise<RedirectParams> => {
    return await apiService.post('/api/param', formParam);
};

export const asyncPostMotiveParam = async (
    formParam: Motive
): Promise<Motive> => {
    return await apiService.post('/api/param/motive', formParam);
};

export const asyncGetParam = async (id: string | number | undefined) => {
    return await apiService.get(`/api/param/${id}`);
};

export const asyncGetMotive = async (
    name: string | undefined,
    active: boolean | undefined
) => {
    return await apiService.get(`/api/param/motive/${name}/${active}`);
};

export const asyncPatchtParam = async (
    id: string,
    formParam: RedirectParams
): Promise<RedirectParams> => {
    return await apiService.patch(`/api/param/${id}`, formParam);
};

export const asyncPatchMotiveParam = async (
    name: string,
    active: boolean,
    formParam: Motive
): Promise<Motive> => {
    return await apiService.patch(
        `/api/param/motive/${name}/${active}`,
        formParam
    );
};

export const asyncGetLastCodeParam = async (classParam?: ParamEnum) => {
    return await apiService.get(`/api/param/last-code/${classParam}`);
};

export const asyncGetParamPqrTimes = async (filters: {
    status?: string;
    receptionChannel?: string;
    type?: string;
    half?: string;
    subtypeDp?: string;
    procedure?: string;
}): Promise<
    | {
          sacTime: number;
          furagTime: number;
      }
    | undefined
> => {
    try {
        const { items }: any = await apiService.get(
            `/api/param/pqr-times`,
            filters
        );
        return items;
    } catch (error) {}
};

export const asyncGetParamsClassName = async (
    classParam?: ParamEnum,
    name?: string,
    extra?: string,
    page?: number,
    pageSize?: number
): Promise<ISelect[]> => {
    try {
        const { items }: any = await apiService.get(`/api/param/class-name`, {
            class: classParam || '',
            name: name || '',
            extra: extra || '',
            limit: pageSize || 0,
            page: page || 0,
        });

        return items || [];
    } catch (error) {
        return [];
    }
};

export const asyncGetMotiveHistorical = async (
    name: string,
    active: boolean
): Promise<MotiveHistorical[] | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: MotiveHistorical[];
        } = await apiService.get(
            `/api/param/motive/${name}/${active}/historical`
        );
        return data;
    } catch (error) {}
};

export const asyncGetRedirectParamHistorical = async (
    id: string
): Promise<RedirectParamsHistorical[] | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: RedirectParamsHistorical[];
        } = await apiService.get(`/api/param/${id}/historical`);

        return data || [];
    } catch (error) {}
};
